var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-column"},[_c('ArticleHeader',{attrs:{"title":"Sparse dictionary learning recovers pleiotropy from human cell fitness screens","dateUpdated":"August 9, 2021"}}),_c('Authors'),_c('AbstractText')],1)}
var staticRenderFns = []

export { render, staticRenderFns }